export const ProjectExperience = [
      {
      projectName: "Version Planning app for FAL planners",
      techStacks: [
        "Angular",
        "Node.js",
        "Hapi.js",
        "MySQL",
        "Single SPA",
        "AWS",
        "Lambda",
        "EC2",
        "S3"
      ],
      description: [
        "A application designed for planning community to refine FAL backlog with optimized planning of aircraft versions with digitalized custo & gantt planning",
        "Contributed to multiple features and reusable components and services that required critical thought.",
        "Assisted with best practices, code quality, refining the process and PR reviews.",
        "Offering technical guidance and mentorship to juniors and peers."
      ],
    },
    {
      projectName: "Multi Channel Conference Device Config. app",
      techStacks: [
        "Angular",
        "Electron",
        "Node.js",
        "P5.js",
        "NgRx",
        "webSockets",
        "SCSS",
        "Angular Material",
      ],
      description: [
        "A cross platform desktop and web application, which is supports windows, mac and web configure and manage the device.",
        "Developed reusable generic components and services. I discovered a new JS library/framework and quickly mastered its use.",
        "Implemented features using canvas frameworks like P5.js and Fabric, web APIs like Media Devices and Navigator.",
        "Delivered complicated features and assisted to integrate the websocket and Rest API.",
      ],
    },
    {
      projectName: "Cross Platform app for a Retail Store",
      techStacks: [
        "React",
        "Redux",
        "Lerna",
        "Single SPA",
        "REST api",
        "SCSS",
        "Material UI",
      ],
      description: [
        "A cross-platform web application with a micro frontend to assist retail store staff in managing walk-in consumers.",
        "Created generic and micro front ends, as well as source code reusability, leveraging Lerna and single-SPA ideas.",
        "Implemented Redux state management, as well as persisting and caching the states.",
        "More than 90% of the developed code has unit tests that were written in Jest. Used best practices to maintain the integrity of the code.",
        "Helping peers who were stuck in the development process. Mentoring the juniors by offering technical guidance.",
      ],
    },
    {
      projectName: "Mobile app for a Retail Store",
      techStacks: [
        "React",
        "React native",
        "Redux",
        "Redux Saga",
        "REST api",
        "Websocket",
        "SCSS",
      ],
      description: [
        "A mobile application for a retail store built with react native with a few native API features such as a camera, IR reader, and file system.",
        "Contributed to features that required critical thought.",
        "Improved debugging and solving problems. Support and troubleshooting assistance in a live environment.",
        "Assisted with best practices, code quality, and PR review.",
      ],
    }
  ];